import PrimeVue from 'primevue/config'
import { pt_BR } from 'primelocale/js/pt_BR.js'
import Tooltip from 'primevue/tooltip'
import Aura from '@primeuix/themes/aura'
import { definePreset } from '@primeuix/themes'
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionPanel,
  Badge,
  Carousel,
  ConfirmationService,
  Paginator,
  Tab,
  TabList,
  TabPanels,
  Tabs,
} from 'primevue'
import {
  Button,
  Card,
  Checkbox,
  Chip,
  Column,
  ConfirmDialog,
  DataTable,
  DatePicker,
  Dialog,
  Divider,
  FileUpload,
  FloatLabel,
  Image,
  InputMask,
  InputNumber,
  InputText,
  Menu,
  Message,
  MultiSelect,
  Popover,
  ProgressSpinner,
  RadioButton,
  Select,
  SplitButton,
  Step,
  StepItem,
  StepList,
  StepPanel,
  StepPanels,
  Stepper,
  Tag,
  Textarea,
  Timeline,
  Toast,
  ToggleSwitch,
  AutoComplete,
  SelectButton,
  Skeleton,
  Fieldset,
  Drawer,
  PanelMenu,
  TabPanel,
} from 'primevue'
import { Form } from '@primevue/forms'

export function   registerPrimeVue(app) {
  const MyPreset = definePreset(Aura, {
    components: {
      toggleswitch: {
        colorScheme: {
          light: {
            root: {
              checkedBackground: 'var(--s-brand-blue)',
              checkedHoverBackground: 'var(--s-brand-blue)',
            },
          },
          dark: {},
        },
      },
      tag: {
        colorScheme: {},
      },
    },
    semantic: {
      colorScheme: {
        light: {
          primary: {
            50: '{zinc.50}',
            100: '{zinc.100}',
            200: '{zinc.200}',
            300: '{zinc.300}',
            400: '{zinc.400}',
            500: '{zinc.500}',
            600: '{zinc.600}',
            700: '{zinc.700}',
            800: '{zinc.800}',
            900: '{zinc.900}',
            950: '{zinc.950}',
          },
        },
        dark: {
          primary: {
            0: '#ffffff',
            50: '{neutral.50}',
            100: '{neutral.100}',
            200: '{neutral.200}',
            300: '{neutral.300}',
            400: '{neutral.400}',
            500: '{neutral.500}',
            600: '{neutral.600}',
            700: '{neutral.700}',
            800: '{neutral.800}',
            900: '{neutral.900}',
            950: '{neutral.950}',
          },
        },
      },
    },
  })

  app.use(PrimeVue, {
    locale: pt_BR,
    zIndex: {
      modal: 3000,
      overlay: 3100,
      menu: 3100,
      tooltip: 9200,
    },
    theme: {
      preset: MyPreset,
      options: {
        prefix: 'p',
        darkModeSelector: '.dark',
        cssLayer: false,
      },
    },
  })

  // Importações do PrimeVue
  // Componentes globais
  app.component('PVButton', Button)
  app.component('PVFileUpload', FileUpload)
  app.component('PVCard', Card)
  app.component('PVToast', Toast)
  app.component('PVDialog', Dialog)
  app.component('PVChip', Chip)
  app.component('PVProgressSpinner', ProgressSpinner)
  app.component('PVMessage', Message)
  app.component('PVInputText', InputText)
  app.component('PVToggleSwitch', ToggleSwitch)
  app.component('PVAutoComplete', AutoComplete)
  app.component('PVInputNumber', InputNumber)
  app.component('PVSelect', Select)
  app.component('PVTimeline', Timeline)
  app.component('PVDivider', Divider)
  app.component('PVDatePicker', DatePicker)
  app.component('PVImage', Image)
  app.component('PVTextArea', Textarea)
  app.component('PVConfirmDialog', ConfirmDialog)
  app.component('PVStepPanel', StepPanel)
  app.component('PVForm', Form)
  app.component('PVRadioButton', RadioButton)
  app.component('PVStepper', Stepper)
  app.component('PVStepList', StepList)
  app.component('PVStepPanels', StepPanels)
  app.component('PVStepItem', StepItem)
  app.component('PVStep', Step)
  app.component('PVInputMask', InputMask)
  app.component('PVCheckBox', Checkbox)
  app.component('PVMenu', Menu)
  app.component('PVColumn', Column)
  app.component('PVDataTable', DataTable)
  app.component('PVTag', Tag)
  app.component('PVFloatLabel', FloatLabel)
  app.component('PVMultiSelect', MultiSelect)
  app.component('PVPopover', Popover)
  app.component('PVSplitButton', SplitButton)
  app.component('PVSelectButton', SelectButton)
  app.component('PVSkeleton', Skeleton)
  app.component('PVFieldset', Fieldset)
  app.component('PVCarousel', Carousel)
  app.component('PVAccordion', Accordion)
  app.component('PVAccordionHeader', AccordionHeader)
  app.component('PVAccordionContent', AccordionContent)
  app.component('PVAccordionPanel', AccordionPanel)
  app.component('PVBadge', Badge)
  app.component('PVPanelMenu', PanelMenu)
  app.component('PVDrawer', Drawer)
  app.component('PVPaginator', Paginator)
  app.component('PVTabs', Tabs)
  app.component('PVTab', Tab)
  app.component('PVTabList', TabList)
  app.component('PVTabPanels', TabPanels)
  app.component('PVTabPanel', TabPanel)

  // Diretivas
  app.directive('pv-tooltip', Tooltip)
  app.use(ConfirmationService)
}
